const STORAGE_KEY = 'setSurveyLive'

/**
 * Get setSurveyLive configuration from localStorage.
 * Returns undefined if not set, allowing the backend to use its default.
 */
export const getSurveyLiveConfig = (): boolean | undefined => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === null) return undefined
  return stored === 'true'
}
